module.exports = __webpack_public_path__ + "img/undraw_my_files_swob.3a99449c.svg";